class Storage {
  constructor(key, value = null) {
    this.key = key;
    this.value = value;
  }

  setItem() {
    return localStorage.setItem(this.key, this.value);
  }

  getItem() {
    const data = localStorage.getItem(this.key);
    return data === 'null' ? false : data;
  }

  removeItem() {
    return localStorage.removeItem(this.key);
  }

  removeAllItems() {
    return localStorage.clear();
  }
}

export default Storage;
